export default __webpack_public_path__ + "static/media/phone.3f6dbca1.png";